export default "__VITE_ASSET__CXek4nHG__"